import React, { useState } from 'react';
import Chart from 'react-apexcharts';

export default function BarChart(props) {
    const [state, setState] = useState(
        {
            series: props.series,
            options: {
                chart: {
                    type: 'bar',
                    height: 350,
                    stacked: true,
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: true
                    }
                },
                title: {
                    text: props.title,
                    align: 'center'
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                plotOptions: {
                    bar: {
                        horizontal: false,
                        borderRadius: 5,
                        dataLabels: {
                            total: {
                                enabled: true,
                                style: {
                                    fontSize: '13px',
                                    fontWeight: 900
                                }
                            }
                        }
                    },
                },
                xaxis: {
                    // type: 'datetime',
                    categories: props.categories_X,
                    title: {
                        text: props.title_X
                    }
                },
                yaxis: {
                    title: {
                        text: props.title_Y
                    }
                },
                legend: {
                    position: 'bottom',
                    offsetY: 10
                },
                fill: {
                    opacity: 1
                }
            },
        }
    )
    return (
        <>
            <Chart
                options={state.options}
                series={state.series}
                type="bar"
                // width={1200}
                height={320}
            />
        </>
    );
}